import { Action } from 'redux'
import { ServicesModal } from '../../../reducers/bookingCalendar/actionNames'
import { IService } from '../../../models/Services'

const servicesAccepted = (
  services: IService[],
  rates = [],
): IServicesAccepted => ({
  rates,
  services,
  type: ServicesModal.ServicesAccepted,
})

export { servicesAccepted }

export interface IServicesAccepted
  extends Action<ServicesModal.ServicesAccepted> {
  services: IService[]
  rates?: any
}
